import { Component, Input, Output, EventEmitter, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';

import { KeySelectItem } from '@core/models/select-item.model';

@Component({
  selector: 'core-helpers-forms-key-select-multiple',
  templateUrl: './key-select-multiple.component.html',
  styleUrls: ['./key-select-multiple.component.scss'],
})
export class KeySelectMultipleComponent implements OnInit, AfterViewInit  {

    @Input() disabled: boolean;
    @Input() scrollTop: number = 0;
    @Input() label: string = "";
    @Input() options: KeySelectItem[] = [];
    @Output() selectValue = new EventEmitter<any>();
    @Output() selectScrollTop = new EventEmitter<number>();
    // list contianer element reference
    @ViewChild("listContainer") private listContainer: ElementRef;


    public selected: any = null;
    // public itemsSelected = [];

    ngOnInit() {
        this.selected = this.getValueSelected();
    }

    ngAfterViewInit(){
        this.listContainer.nativeElement.scrollTo(0, this.scrollTop);
    }

    onChange(){
        this.selected = this.options.filter( o => { return o.selected}).map(o => o.key );
        this.selectValue.emit(this.selected);
        // emit scroll value to in case we eant to save it
        this.selectScrollTop.emit(this.listContainer.nativeElement.scrollTop);
    }

    protected getValueSelected() {
        return this.options.filter( o => { return o.selected}).map(o => o.key);
    }
}
